const styles = {
    avatar: {
        verticalAlign: 'middle',
        display: 'block',
        margin: 'auto',
        marginBottom: 40
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/media/MediaType/MediaTypeFull/MediaTypeFull.css.js